<template>
	<v-app-bar fixed app height="65" style="width: auto;">
        <!-- >>> Drawer -->
        <v-btn
            style="margin-left: 5px !important"
            depressed
            elevation="1"
            min-width="0"
            @click="$vuetify.breakpoint.smAndDown ? setDrawer(!drawer) : $emit('input', !value)">
            <v-icon v-if="value">
                mdi-view-quilt
            </v-icon>

            <v-icon v-else>
                mdi-dots-vertical
            </v-icon>
        </v-btn>
        <!-- <<< Drawer -->


		<v-toolbar-title class="hidden-sm-and-down">
            SunFlight - Slot Manager
        </v-toolbar-title>


		<div style="display:flex;align-content:center;width:100%">
            <v-col md="3" style="margin-top:30px;padding-left:30px;">
                <v-menu
                    ref="dateRangeMenu"
                    v-model="dateRangeMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                        <!-- prepend-icon="mdi-clock-start" -->
                        <v-combobox
                            ref="input_dateRange"
                            v-model="formattedDateRange"
                            v-bind="attrs"
                            label="Date Range"

                            prepend-icon="mdi-calendar"
                            v-on="on" />
                    </template>
                    <v-date-picker
                        v-model="input_dateRange"
                        :first-day-of-week="1"
                        range />
                </v-menu>
            </v-col>

            <v-col md="3" style="margin-top:30px;">
                <v-combobox
                    v-model="input_flightNumber"
                    :items="flightNumbers"
                    class="uppercase"
                    label="Flight Number"
                    maxlength="8"
                    prepend-icon="mdi-numeric"
                    clearable
                    @input="onClick_setFilter()"
                />
            </v-col>

            <v-col md="2" style="margin-top:30px;">
                <v-combobox
                    v-model="input_departureAirport"
                    label="Departure Airport"
                    :items="get_Airports"
                    item-text="iataCode"
                    item-value="iataCode"
                    prepend-icon="mdi-airplane-takeoff"
                    clearable

                    @input="onChange_departureAirport(), onClick_setFilter()"
                    />
            </v-col>
            <v-col md="2" style="margin-top:30px;">
                <v-combobox
                    v-model="input_destinationAirport"
                    label="Destination Airport"
                    :items="get_Airports"
                    item-text="iataCode"
                    item-value="iataCode"
                    prepend-icon="mdi-airplane-landing"
                    clearable

                    @input="onChange_destinationAirport(), onClick_setFilter()"
                    />
            </v-col>
            <v-col style="align-items:center;justify-content: center;display:flex" md="1">
                <!-- >>> Menu: Filter -->
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :close-on-click="false"
                    :nudge-width="400"
                    max-width="453"
                    bottom
                    left
                    origin="top right"
                    transition="scale-transition"
                    offset-y>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            raised elevation="1" min-width="0" text
                            @click="menu=true, backupLocalState()">
                            <v-icon>mdi-filter-outline</v-icon>
                        </v-btn>
                    </template>

                    <v-card style="margin-bottom:0;margin-top:0;">
                        <v-card-title class="headline">
                            <p class="pl-7 mb-8 mt-8">
                                Filter Flights
                            </p>
                        </v-card-title>

                        <v-form>
                            <!-- >>> Form, Fields -->
                            <v-list>
                                <v-list-item>
                                    <v-combobox
                                        v-model="input_aircrafts"
                                        :items="get_AircraftConfigs"
                                        item-text="code"
                                        item-value="idAircraft"
                                        label="Select one/more Aircrafts(s)"
                                        prepend-icon="mdi-airplane"
                                        clearable
                                        multiple
                                        small->
                                    >
                                    </v-combobox>
                                </v-list-item>

                                <v-list-item class="mt-2">
                                    <v-icon style="margin-right:11px;margin-left:3px;margin-bottom:auto;margin-top:30px;">
                                        mdi-calendar
                                    </v-icon>
                                    <div style="width:100%;">
                                        <p style="color:rgba(0,0,0,.87);font-size:0.7rem;" class="ma-0 mb-n1 text-left">
                                            Day
                                        </p>
                                        <v-chip-group
                                            v-model="input_Days"
                                            pre
                                            multiple
                                            active-class="sdr-chip--active">
                                            <v-chip v-for="day in items_Days" :key="day.text" small class="mx-1" :value="day.value">
                                                {{ day.text }}
                                            </v-chip>
                                        </v-chip-group>
                                        <v-divider class="mb-4 mt-1 grey lighten-1" />
                                    </div>
                                </v-list-item>

                                <v-list-item class="mt-2">
                                    <v-select
                                        v-model="input_slotStatus"
                                        :items="items_slotStatus"
                                        label="Slot Status"
                                        multiple
                                        clearable
                                        prepend-icon="mdi-check-all"

                                    />
                                </v-list-item>
                                <div style="display: flex; margin-top: 16px;">
                                    <div style="padding: 0 30px; display: flex;">
                                        <v-switch v-model="input_deletedFlights" style="margin: 0; padding: 0;" label="Show deleted flights" />
                                    </div>

                                    <div style="padding: 0 30px; display: flex;">
                                        <v-switch v-model="input_showOnlySlots" style="margin: 0; padding: 0;" label="Show only Flights with Slot issues" />
                                    </div>
                                </div>
                            </v-list>


                            <!-- >>> Action Buttons -->
                            <v-card-actions style="padding-bottom:10px;">
                                <v-spacer />
                                <v-btn style="width:130px; font-size:16px;" depressed elevation="1" outlined color="#ab3b7a" @click="onClick_cancelFilter">
                                    Cancel
                                </v-btn>
                                <v-btn class="mr-2" style="width:130px; font-size:16px;" depressed elevation="1" color="primary" @click="onClick_setFilter(), onClick_searchFlights(), menu = false">
                                    Set Filter
                                </v-btn>
                            </v-card-actions>
                            <!-- <<< Action Buttons -->
                        </v-form>
                    </v-card>
                </v-menu>
                <!-- <<< Menu: Filter -->
            </v-col>
            <v-col style="align-items:center;justify-content: center;display:flex" md="1">
                <v-btn
                    depressed elevation="1" min-width="0" color="#ab2b7a"
                    @click="onClick_searchFlights">
                    <v-icon style="color: #ffffff !important;">
                        mdi-reload
                    </v-icon>
                </v-btn>
            </v-col>
        </div>



		<v-spacer />


        <!-- >>> Comes later ... -->
		<!-- <v-btn icon rounded tile style="margin-left: 40px; margin-right: 0px;">
			<v-icon color="primary">
				mdi-overscan
			</v-icon>
		</v-btn> -->
        <!-- <<< Comes later ... -->
	</v-app-bar>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters, mapActions } from 'vuex';
    import dayjs from 'dayjs';
    import { eventBus } from '../../../../../main';


	export default {
		name: 'FlightsAppBar',

        /* >>> *************************************************************** / /* Props */
        props: {

            value: {
                type: Boolean,
                default: false
            },
            flights_dateRange: Array

        }, // eo props{}
        /* <<< ****************************************************************/

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> ------------------------------------ Filter
				input_flightNumber: '',
				dateRangeMenu: false,
				formattedDateRange: '',
				input_dateRange: [],
				input_departureAirport: null,
				input_destinationAirport: null,

				// >>> ------------------------------------ Menu: Filter
				menu: false,
				input_aircrafts: [],
				input_Days: [1, 2, 3, 4, 5, 6, 0],
				items_Days: [
                    { text: '1', value: 1, backendValue: 'MONDAY' },
                    { text: '2', value: 2, backendValue: 'TUESDAY' },
                    { text: '3', value: 3, backendValue: 'WEDNESDAY' },
                    { text: '4', value: 4, backendValue: 'THURSDAY' },
                    { text: '5', value: 5, backendValue: 'FRIDAY' },
                    { text: '6', value: 6, backendValue: 'SATURDAY' },
                    { text: '7', value: 0, backendValue: 'SUNDAY' }
                ],
				input_deletedFlights: false,
				input_slotStatus: [],
				items_slotStatus: [
					'OPEN',
					'REQUESTED',
					'GRANTED'
				],
                input_showOnlySlots: false,
				// >>> ------------------------------------ Backup
				backup_input_dateRange: [],
				backup_input_aircrafts: [],
				backup_input_Days: [],
				backup_input_slotStatus: [],
				backup_input_deletedFlights: false
            };

        }, // eo function created()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
				'get_Flights_Filtered',
                'get_SlotsTable_Slots_Filtered',
                'get_Airports',
                'get_AircraftConfigs'
			]),

            /*******************************************************************
            * flightNumbers{}
            *
            * Desc:
            * Note:
            *
            */
			flightNumbers: {
				get() {

					const me = this;
                    let setOfFlightNumbers = [];


					me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> computed/flightNumbers/get');
					setOfFlightNumbers = me.get_Flights_Filtered;
                    setOfFlightNumbers = [...new Set(setOfFlightNumbers)];
                    //TODO: take filtered Slots

                    return setOfFlightNumbers.map(f => f.flightNo);
				},

				set(val) {

					const me = this;


					me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> computed/flightNumbers/set');
					return val;
				}
			} // eo function flightNumbers

        }, // eo computed
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* watch */
        watch: {

            /*******************************************************************
            * input_dateRange{}
            *
            * Desc:
            * Note:
            *
            */
            input_dateRange (val) {

                const me = this;
                const formattedDates = [];


				me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> watch > input_dateRange');
                //if there are two dates selcted (range)
                //check if the first date is NOT before the second date
                if (val.length === 2) {
                    //switch dates, so the range is valid
                    if (dayjs(val[0]).isAfter(dayjs(val[1]))) {
                        //switch val[0] und val[1]
                        [val[0], val[1]] = [val[1], val[0]];
                    }
                }

                //loop over date range, and save formatted date
                me.input_dateRange.forEach(date => {
                    formattedDates.push(dayjs(date).format('DD.MM.YYYY'));
                });

                me.formattedDateRange = formattedDates.join(' - ');

            }, // eo function input_dateRange()

			/*******************************************************************
            * input_dateRange{}
            *
            * Desc:
            * Note:
            *
            */
			dateRangeMenu (val) {

				const me = this;


				me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> watch > dateRangeMenu');
				if (me.input_dateRange === me.backup_input_dateRange) {		// prevent reload if we are looking for the same date range
					return;
				}

				if (val === false) {

					me.onClick_searchFlights();
					me.backup_input_dateRange = me.input_dateRange;
				}
			} // eo function dateRangeMenu()

        }, // eo funtion data()
        /* <<< ****************************************************************/

        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

			const me = this;

			me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> created');
            me.input_aircrafts = me.get_AircraftConfigs;

		}, // eo watch{}
        /* <<< ****************************************************************/

        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted() {

            const me = this;

			me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> mounted');
            me.onCreate_setInitialStates();

        }, // eo function mounted()

        /* >>> *************************************************************** / /* Methods */
        methods: {

			...mapActions([
                'actn_call_getFlights',
                'actn_call_slotmanagement_getSlots',
                'actn_set_filter_filterTerm'
			]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
           /*******************************************************************
			* onCreate_setInitialStates()
			*
			* Desc:
			* Note:
			*
			*/
			onCreate_setInitialStates: function() {

				const me = this;
				let filterPayload = {};


				me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> onCreate_setInitialStates');
				filterPayload = {
					flightNumber: me.input_flightNumber,
					deletedFlights: me.input_deletedFlights,
					departureAirport: me.input_departureAirport,
					destinationAirport: me.input_destinationAirport,
					slotStatus: me.input_slotStatus,
					days: me.input_Days.map(d => d),
					aircrafts: me.input_aircrafts.map(a => a.idAircraft)
				};
				me.actn_set_filter_filterTerm(filterPayload);
				me.input_dateRange = me.flights_dateRange || [
					dayjs().format('YYYY-MM-DD'),
					dayjs().add(31, 'days').format('YYYY-MM-DD')
				];
                me.actn_call_getFlights(
                    {
                        flightNo: '',
                        from: dayjs(me.input_dateRange[0]).format('YYYY-MM-DDT00:00:00[Z]'), //"2021-04-30T00:00:01Z"
                        fromAptCode: null,
                        idFlight: null,
                        to: dayjs(me.input_dateRange[1]).format('YYYY-MM-DDT23:59:59[Z]'), //"2021-04-30T23:59:59Z"
                        toAptCode: null,
                        DOW: me.input_Days.map((day) => {
                            return me.items_Days.find(i => i.value === day).backendValue;
                        }),
                        idAircraftConfig: me.get_AircraftConfigs.map(a => {
                            return a.id;
                            // <<< CAR added undefined
                        }),
                        slot: me.input_showOnlySlots
                    }
                );
                me.actn_call_slotmanagement_getSlots({
                    fromDate: dayjs(me.input_dateRange[0]).format('YYYY-MM-DDT00:00:00[Z]'),
                    toDate: dayjs(me.input_dateRange[1]).format('YYYY-MM-DDT23:59:59[Z]')
                });

			}, // eo function onCreate_setInitialStates()

            /*******************************************************************
            * onClick_setFilter()
            *
            * Desc: Sets Filter Term into state
            * Note:
            *
            */
			onClick_setFilter: function(event) {

                const me = this;
				let payload = {};


				me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> onClick_setFilter');
				payload = {
					flightNumber: (event ? event.srcElement.value : (me.input_flightNumber ? me.input_flightNumber : '')),
					deletedFlights: me.input_deletedFlights,
					departureAirport: me.input_departureAirport,
					destinationAirport: me.input_destinationAirport,
					slotStatus: me.input_slotStatus,
					days: me.input_Days.map(d => d),
					aircrafts: me.input_aircrafts.map(a => a.idAircraft)
				};

				me.actn_set_filter_filterTerm(payload);
                //me.onClick_searchFlights(); // TODO: Try not to load all flights again

			}, // eo function onClick_setFilter()

			/*******************************************************************
            * onClick_cancelFilter()
            *
            * Desc: Close Filter Menu
            * Note:
            *
            */
			onClick_cancelFilter: function() {

                const me = this;



				me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> onClick_cancelFilter');
				me.recoverLocalState();
				me.menu = false;

			}, // eo function onClick_cancelFilter()

			/*******************************************************************
            * onClick_searchFlights()
            *
            * Desc: Triggers Call to search Flights
            * Note:
            *
            */
			onClick_searchFlights: function(payload) {

                const me = this;


				me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> onClick_searchFlights');
				me.dataTable_selected = [];
				if (me.input_dateRange.length === 1) {
					me.input_dateRange[1] = me.input_dateRange[0];
				}

                me.actn_call_getFlights(
                    {
                        flightNo: me.input_flightNumber,
                        from: dayjs(me.input_dateRange[0]).format('YYYY-MM-DDT00:00:00[Z]'), //"2021-04-30T00:00:01Z"
                        fromAptCode: null,
                        idFlight: null,
                        to: dayjs(me.input_dateRange[1]).format('YYYY-MM-DDT23:59:59[Z]'), //"2021-04-30T23:59:59Z"
                        toAptCode: null,
                        DOW: me.input_Days.map((day) => {
                            return me.items_Days.find(i => i.value === day).backendValue;
                        }),
                        idAircraftConfig: me.input_aircrafts.map(a => {
                            return a.id;
                            // <<< CAR added undefined
                        }),
                        slot: me.input_showOnlySlots
                    }
                );
                me.actn_call_slotmanagement_getSlots({
                    fromDate: dayjs(me.input_dateRange[0]).format('YYYY-MM-DDT00:00:00[Z]'),
                    toDate: dayjs(me.input_dateRange[1]).format('YYYY-MM-DDT23:59:59[Z]')
                });

			}, // eo function onClick_searchFlights()

			/*******************************************************************
            * onChange_departureAirport()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_departureAirport: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> onChange_departureAirport');
                if (Vue.prototype.$isEmpty(me.input_departureAirport)) {
					me.input_departureAirport = null;	// clear button pressed -> reset state
                    return;
                }

                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof me.input_departureAirport !== 'object') {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.input_departureAirport.toUpperCase());
                } else {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.input_departureAirport.iataCode.toUpperCase());
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    me.input_departureAirport = airport.iataCode;
                } else {
                    me.input_departureAirport = null;
                }


            }, // eo function onChange_departureAirport()

			/*******************************************************************
            * onChange_directFlight_Destination()
            *
            * Desc: Use Combobox Input to find the corresponding airport-object.
            * Note: Reset if no airport-object fits the input.
            * Note: Replace the Input with the airport-object if found.
            * Note: After colleciton the airport-object trigger
            * Note: onChange-Prop-Function.
            *
            */
            onChange_destinationAirport: function() {

                const me = this;
                let airport;


                me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> onChange_destinationAirport');
                if (Vue.prototype.$isEmpty(me.input_destinationAirport)) {
					me.input_destinationAirport = null;	// clear button pressed -> reset state
                    return;
                }
                // comboboxFillAirport
                // if input is object -> we have already found an airport-object
                // if input is not object -> we need to find an airport-object
                if (typeof me.input_destinationAirport !== 'object') {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.input_destinationAirport.toUpperCase());
                } else {
                    airport = me.get_Airports.find(airport => airport.iataCode === me.input_destinationAirport.iataCode.toUpperCase());
                }

                // if airport-object found -> set as "new" input
                // if airport-object not found -> "reset" input
                if (airport !== undefined) {
                    me.input_destinationAirport = airport.iataCode;
                } else {
                    me.input_destinationAirport = null;
                }

            }, // eo function onChange_directFlight_Destination()

            /*******************************************************************
			* backupLocalState()
			*
			* Desc:
            * Note:
            *
			*/
            backupLocalState: function() {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> backupLocalState');
				me.backup_input_aircrafts = me.input_aircrafts;
				me.backup_input_Days = me.input_Days;
				me.backup_input_slotStatus = me.input_slotStatus;
				me.backup_input_deletedFlights = me.input_deletedFlights;

            }, // eo function backupLocalState()


            /*******************************************************************
			* recoverLocalState()
			*
			* Desc:
            * Note:
            *
			*/
            recoverLocalState: function() {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/AppBar.vue >>> recoverLocalState');
				me.input_aircrafts = me.backup_input_aircrafts;
				me.input_Days = me.backup_input_Days;
				me.input_slotStatus = me.backup_input_slotStatus;
				me.input_deletedFlights = me.backup_input_deletedFlights;

            } // eo function recoverLocalState()

        } // eo methods
        /* <<< ****************************************************************/
	};
</script>

<style scoped>
	.theme--light.v-app-bar.v-toolbar.v-sheet {
		background-color: #FFFFFF;
		border-color: #FFFFFF;
		color: rgba(0, 0, 0, 0.87);
	}

	.v-toolbar__title {
		font-weight: 300;
		color: #555555;
		font-size: 18px;
		margin-bottom: 0px;
	}

	.theme--light.v-btn.v-btn--has-bg {
		background-color: #fff;
	}

    .v-label {
        font-size: 14px !important; /* 16px */
    }

    .sdr-custom-text-input input {
        text-transform: uppercase;
    }

</style>

<style>
    .sdr-custom-button-with-icon .v-icon::before {
        color: #AB3B7A;
    }

    .sdr-custom-button-with-icon.v-btn--disabled .v-icon::before {
        color: #e0e0e0;
    }

    .v-slider__tick, .v-slider__tick.v-slider__tick--filled {
        width: 7px !important;
        height: 7px !important;
        border-radius: 50%;
        margin-top: -3px;
        margin-left: -3px;
        background: #AB3B7A;
        cursor: pointer;
    }

    .v-slider__tick:first-of-type .v-slider__tick-label {
        transform: translateX(-50%) !important;
    }

    .v-slider__tick:last-of-type .v-slider__tick-label {
        transform: translateX(-25%) !important;
    }

    .theme--light.v-label {
		color: rgba(0, 0, 0, 0.7);
	}
</style>
